import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["file"];

  attached() {
    var file = new Blob([this.fileTarget.files[0]], { type: "application/pdf" });
    var fileURL = URL.createObjectURL(file);
    document.getElementById("iframe1").src = fileURL;
  }
}
